<template>
	<v-container fluid grid-list-lg class="pa-3">
		<v-layout row wrap>
			<v-flex>
				<v-card>
					<v-toolbar dense prominent>
						<v-toolbar-title>Attendance Records Upload Data</v-toolbar-title>
						<v-spacer></v-spacer>

						<v-toolbar-items>
							<v-tooltip bottom>

								<template v-slot:activator="{ on }">
									<v-btn color="primary" small fab v-on="on" :href="'/assets/files/template_upload_fpes_attn_record.csv'" download>
										<v-icon>sim_card_download</v-icon>
									</v-btn>
								</template>
								<span>Download temlate</span>
							</v-tooltip>

							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<input type="file" ref="fileUpload" accept=".csv" v-show="false" />
									<v-btn color="primary" small fab v-on="on" @click="upload_onclick">
										<v-icon>upload</v-icon>
									</v-btn>
								</template>
								<span>Upload file</span>
							</v-tooltip>

						</v-toolbar-items>
					</v-toolbar>

					<v-card-title>
						Information :
					</v-card-title>

					<v-card-text class="pa-0">
						<v-data-table :pagination.sync="table.pagination" :rows-per-page-items="table.rows_per_page_items" :total-items="table.total_items" :headers="table.headers.filter(r => r.viewable == true)" :loading="table.loading" :items="table.items">

							<template v-slot:items="props">
								<td class="text-xs-center">{{ props.item.no }}</td>
								<td v-for="header in csv.headers" :key="header" class="text-xs-center">{{ props.item[header] }}</td>
							</template>
						</v-data-table>

						<v-btn fixed fab bottom right color="primary" @click="submit_onclick">
							<v-icon>save</v-icon>
						</v-btn>

					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import general from "../../functions/general";
//import auth from "../../functions/auth";
//import communication from "../../functions/communication.api";

let MAX_FILE_SIZE = 1024 * 1024 * 1; // 1 Mbytes

export default {
	name: "Admin-Upload",
	mounted() {
		general.App.set_page_title("mySuite : Admin Upload Data");
		this.$refs.fileUpload.addEventListener('change', this.checkIt);
	},
	data() {
		return {
			csv: {
				records: [],
				headers: [],
			},
			table: {
				headers: [],
				items: [],
				total_items: 0,
				rows_per_page_items: [25, 50, 100, 200, 1000],
				loading: false,
				pagination: {
					descending: true,
					page: 1,
					rowsPerPage: -1,
					sortBy: "date",
					totalItems: 100
				},
			},
		};
	},
	computed: {},
	methods: {
		async submit_onclick(){
			let base = "fpes/upload_others_factor_data/";

			general.App.loader.show(this);

			var res = await general.wBackEndComm.PostData(base, this.table.items);
			res = await res.data;

			if(res.Status == 1){
				this.table.items = res.Body;
			}

			general.App.loader.hide(this);
		},
		async upload_onclick() {
			general.App.loader.show(this);
			await this.$refs.fileUpload.click();

		},
		async checkIt() {
			let Files_Error = [];
			let self = this;

			if (this.$refs.fileUpload.files.length == 0) {
				return;
			}

			for (let i = 0, m = this.$refs.fileUpload.files.length; i < m; i++) {
				let file = this.$refs.fileUpload.files[i];

				if (file.size > MAX_FILE_SIZE) {
					Files_Error.push(file);
				}
			}

			if (Files_Error.length > 0) {
				var file_name = Files_Error.map(el => el.name);
				var error_msg = `${file_name.length} file(s) exceeded file size limit. (1 Mbytes per file)`;
				general.wMsgBox.Error(error_msg);
			} else {
				let reader = new FileReader();

				reader.onload = function () {
					let all_content = reader.result;

					try {
						self.parseCSV(all_content);
						self.populate_table();
					} catch (error) {
						general.wMsgBox.Error(error.message);
					}

				}
				reader.readAsText(this.$refs.fileUpload.files[0]);
			}
			general.App.loader.hide(this);
		},
		populate_table() {
			this.populate_table_headers();

			this.table.items = this.csv.records;
		},
		populate_table_headers() {
			function new_obj() {
				let obj = {
					text: "",
					value: "",
					align: "center",
					sortable: true,
					viewable: true,
					type: "String",
					class: "font-weight-black",
					width: ""
				}
				return obj;
			}
			let temp_arr = [];
			let temp_obj = new_obj();

			temp_obj.text = "no";
			temp_obj.value = "no";
			temp_arr.push(temp_obj);

			for (let i = 0, m = this.csv.headers.length; i < m; i++) {
				let obj = new_obj();

				obj.text = this.csv.headers[i];
				obj.value = this.csv.headers[i];

				temp_arr.push(obj);
			}

			this.table.headers = temp_arr;
		},
		parseCSV(content) {
			let all_rows = content.split("\r\n");

			if (all_rows.length < 2) {
				throw new Error("File found no content.");
			}
			let arr_headers = all_rows[0].split("|");

			let all_records = [];

			for (let idx = 1, max = all_rows.length; idx < max; idx++) {
				let obj_record = {};
				let row = all_rows[idx].split("|");

				for (let ii = 0, mm = arr_headers.length; ii < mm; ii++) {
					if (["date", "username"].indexOf(arr_headers[ii]) > -1) {
						obj_record[arr_headers[ii]] = row[ii];
					} else {
						let value = row[ii];

						if (value.trim().length > 0) {
							obj_record[arr_headers[ii]] = parseFloat(value);
						} else {
							obj_record[arr_headers[ii]] = null;
						}
					}
				}

				obj_record["no"] = idx;
				obj_record["status"] = "";
				obj_record["remark"] = "";
				all_records.push(obj_record);
			}

			arr_headers.push("status");
			arr_headers.push("remark");
			this.csv.records = all_records;
			this.csv.headers = arr_headers;
		},
	},
};
</script>

<style scoped>
.v-datatable.v-table .v-datatable__actions {
	display: none;
}
</style>
